import { createFileRoute } from '@tanstack/react-router'
import { InterviewPage } from '@thom/folio-ui/pages/interview'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug_/interview/$ticket')({
	component: InterviewPage,
})
